import React from "react";
import NuvaiWebsite from "./NuvaiWebsite";

function App() {
  return <NuvaiWebsite />;
}

export default App;
